export const PERFORMANCE_CHART_COLORS = [
  "#2563eb",
  "#047857",
  "#be123c",
  "#7c3aed",
  "#0891b2",
  "#db2777",
  "#ca8a04",
  "#475569",
];

export const PERFORMANCE_AXIS_LABEL = {
  color: "#374151",
  fontFamily: "Poppins",
  fontSize: 13,
};

export const PERFORMANCE_AXIS_NAME = {
  color: "#111827",
  fontFamily: "Poppins",
  fontSize: 14,
  fontWeight: 600,
};

export const PERFORMANCE_LEGEND_TEXT = {
  color: "#1f2937",
  fontFamily: "Poppins",
  fontSize: 13,
};

export const PERFORMANCE_SPLIT_LINE = {
  lineStyle: {
    color: "#eceff3",
    type: "dashed",
  },
};

export const PERFORMANCE_AXIS_LINE = {
  lineStyle: {
    color: "#d1d5db",
  },
};
